import { mapState, mapGetters, mapActions, mapMutations } from 'vuex';
import actions from './actions';
import getters from './getters';
import mutations from './mutations';
import state from './state';

export const serviceComputed = {
	...mapState('queueRecordCountStore', Object.keys(state)),
	...mapGetters('queueRecordCountStore', Object.keys(getters))
};
export const serviceMethods = {
	...mapActions('queueRecordCountStore', Object.keys(actions)),
	...mapMutations('queueRecordCountStore', Object.keys(mutations))
};
